// extracted by mini-css-extract-plugin
module.exports = {"cell":"Table_cell_LV_Jz","inactive":"Table_inactive_2-W90","badge":"Table_badge_3TZbb"};